import axios from "axios"
import { appConstants } from '../../_constants';
export const request = (path, data, method) => {  
		
		return axios({
			method: method,
			url: `${appConstants.WEB_SERVICE_URL}/${path}`,
			  headers: {
			   'crossDomain': true,
			   "authorization":localStorage.getItem("JWTTOKEN")
			  },
			data: data,				     
		}) 		
	}
export const postRequest = (path, data) => request(path, data, "POST")
export const putRequest = (path, data) => request(path, data, "PUT")



// WEBPACK FOOTER //
// ./src/api/Admin/helper.js